<!--suppress CssUnresolvedCustomProperty -->
<template>
    <div class="bg_main">
        <div class="primary"></div>
        <v-container>
            <Cart1
                v-if="currentCartStep === 1"
                :next-step="nextStep"
            />

            <Cart2
                v-if="currentCartStep === 2"
                :next-step="nextStep"
            />

            <Cart3
                v-if="currentCartStep === 3"
            />
        </v-container>


    </div>
</template>

<script>
import Cart1 from "../components/Portfolio/Cart1/Cart1";
import Cart2 from "../components/Portfolio/Cart2/Cart2";
import Cart3 from "../components/Portfolio/Cart3/Cart3";
import * as Storage from '@/core/storage.js'

export default {
    name: "Portfolio",
    components: {
        Cart1, Cart2, Cart3
    },

    data() {
        return {
            currentCartStep: 0
        }
    },

    mounted() {
        this.currentCartStep = parseInt(this.$route.params.step)
    },

    created() {
        this.$gtag.event('portafolio_pago', { method: 'Google' }) // Google Analytics
    },

    watch: {
        $route(){
            this.currentCartStep = parseInt(this.$route.params.step)
        }
    },

    methods: {
        nextStep: function (stepFrom, data) {
            switch (stepFrom) {
                case 1:
                    Storage.setItem('cart2', JSON.stringify(data))
                    break
                case 2:
                    Storage.setItem('cart3', JSON.stringify(data))
                    break
                default:
                    Storage.setItem('cart1', JSON.stringify(data))
                    break
            }

            //this.currentCartStep = stepFrom + 1
            this.$router.push({name: 'portfolio', params: {step: stepFrom+1}})
        }
    },
}
</script>

<style>


</style>